// getEndYear — năm của ngày kết thúc đề tài, dùng làm 2 số {yy} trong mã đề tài
// (SVNCKH_<khoa>_{yy}.{seq} / ĐTCS_<khoa>_{yy}.{seq}).
//
// Trả 0 khi thiếu hoặc không hợp lệ — kể cả zero-time của Go ("0001-01-01"),
// vốn là một Date hợp lệ nên nếu không chặn sẽ ra mã {yy} = 01. BE nhận 0 thì
// tự fallback sang schoolYear + 1.
export const getEndYear = (raw) => {
  if (!raw) return 0;
  const d = new Date(raw);
  if (isNaN(d.getTime())) return 0;
  const y = d.getFullYear();
  return y >= 2000 ? y : 0;
};

export default getEndYear;
